import { LaunchKeyDates } from "@oldDashboard/legacyModels/launchKeyDates.model";
import { LaunchKeyDatesSerializer } from "@oldDashboard/legacyModels/serializers/launchKeyDatesSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandLaunchKeyDates {
    async run(afiliateSelected: String, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, sort: String) {  
        const path = `launch-keydates-summary/?affiliate_id=${afiliateSelected}&launch_id=${launchSelected}&time_period=${timePeriodSelected}&start_date=${startDate}&end_date=${endDate}&sort=${sort}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response.chart_data);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : LaunchKeyDates{
        const serializer = new LaunchKeyDatesSerializer();
        return serializer.deserialize(data);
    }
}

